import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import NavigationPrompt from 'react-router-navigation-prompt';
import { Modal } from 'components/atoms/modal';
import { setDirtyState } from 'data/templates';
import { toggleProjectToTemplate } from 'data/templates/projects';
import { selectDirtyState } from 'data/templates/selectors';
import { useTranslation } from 'hooks/use-translation';

export const TemplateUnsavedPrompt: FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const unsavedChangesTitle = useTranslation(
    'templates.confirm.unsaved_changes_title',
  );
  const unsavedChangesText = useTranslation(
    'templates.confirm.unsaved_changes_text',
  );
  const okButtonText = useTranslation('templates.confirm.unsaved_changes_ok');
  const cancelButtonText = useTranslation(
    'templates.confirm.unsaved_changes_cancel',
  );
  const id = location.pathname.split('/')[3];
  const activeId = id === 'new' ? 'new' : parseInt(id, 10);
  const dirty = useSelector(selectDirtyState(activeId));
  const isDirty = useCallback(
    (crntLocation, nextLocation) => {
      // Do not prompt when user navigates between project templates spaces and phases
      // and when creating new status updates & docs
      return (
        !!dirty?.state &&
        crntLocation.pathname !== nextLocation.pathname &&
        !nextLocation.pathname.startsWith('/templates/projects/') &&
        !nextLocation.pathname.startsWith('/templates/status-updates/') &&
        !nextLocation.pathname.startsWith('/templates/documents/')
      );
    },
    [dirty],
  );

  const afterConfirm = () => {
    dispatch(
      setDirtyState({
        id: 0,
        _state: false,
      }),
    );

    dispatch(
      toggleProjectToTemplate({
        isProjectToTemplate: false,
      }),
    );
  };

  return (
    <NavigationPrompt when={isDirty} afterConfirm={afterConfirm}>
      {({ isActive, onCancel, onConfirm }) => {
        if (isActive) {
          return (
            <Modal
              title={unsavedChangesTitle}
              visible
              onOk={onConfirm}
              onCancel={onCancel}
              okText={okButtonText}
              okType="danger"
              cancelText={cancelButtonText}
            >
              <p>{unsavedChangesText}</p>
            </Modal>
          );
        }

        return <></>;
      }}
    </NavigationPrompt>
  );
};
